<template>
  <div style=" background-color: #212f52; height: content-box">
    <el-header style="font-size: 12px; ">
      <el-tabs v-model="activeName">
        <el-tab-pane v-for="item in pageData" :key="item.id" :label="item.name" :name="item.name">
          <component :is="item.content" :itemData="item.data" v-if="activeName === item.name"></component>
        </el-tab-pane>
      </el-tabs>
    </el-header>
  </div>
</template>

<script>
import dzsgl from "./dzsgl.vue";
import dzsflgl from "./dzsflgl.vue";
export default {
  data() {
    return {
      activeName: "实验目标",
      pageData: [
        {
          id: "t01",
          name: "实验目标",
          content: "dzsgl",
          data: "实验目标"
        }/*,
        {
          id: "t02",
          name: "电子书分类管理",
          content: "dzsflgl",
          data: "电子书分类管理"
        }*/
      ]
    }
  },
  components: {
    dzsgl,
    dzsflgl
  },
  props: ["itemData"]
};
</script>

<style lang="less" scoped>
  /deep/ .el-tabs__item {
    color: white;
  }
  /deep/ .el-tabs__item.is-active {
    color: #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/dzs/index.vue